const ERROR_MESSAGES = {
  EMAIL_TAKEN:
    'This email is already in use by another account! Try another email address, or visit https://help.anchor.fm if you have any questions.',
  VANITY_SLUG_TAKEN: 'This Anchor URL is already in use.',
  PODCAST_NAME_NOT_ALLOWED: 'podcastNameNotAllowed',
};

export { ERROR_MESSAGES };
